<template>
  <div>
    <div>
      <b-modal :visible="visible" centered hide-header hide-footer no-close-on-backdrop>
        <div class="d-block text-center modal-container">
          <div class="content-header">{{ $t('selfcheck.closeCheckPageConfirmation') }}</div>
          <div class="content-desc">{{ $t('selfcheck.abortCheckAndBackToMainConfirmation') }}</div>
          <div class="content-button">
            <so-button @click="$emit('cancel')">{{ $t('common.cancel') }}</so-button>
            <so-button variant="red" @click="$emit('confirm')">{{ $t('common.yes') }}</so-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SoButton from '@/components/common/SoButton'

export default {
  name: 'SelfcheckBrowserBackModal',
  components: {
    SoButton,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content-header {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 16px;
}

.content-desc {
  text-align: start;
  padding: 16px 0 0;
  margin-bottom: 16px;
  white-space: pre-wrap;
}

.content-button {
  display: flex;
  justify-content: center;
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.content-button {
  & .button + .button {
    margin-left: 8px;
  }
}
</style>
